var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.getLocation}},[_vm._v(" 打卡上/下班 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }